export default __webpack_public_path__ + "static/media/grafema_ss-wedding-identity_08.93dfe6df.jpg";